import React, { FC } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';

import ControlGrouper from '../_ControlGrouper';
import { ControlGroupProps } from './ControlGroup';

const withControlGrouper = (WrappedComponent: FC<ControlGroupProps>) => {
  const WithControlDefaultProps = {};

  const WithControlGrouper = (props: ControlGroupProps) => (
    <ControlGrouper>
      {({ errors, warnings, messages }) => (
        <WrappedComponent
          errors={errors}
          warnings={warnings}
          messages={messages}
          {...props}
        />
      )}
    </ControlGrouper>
  );

  WithControlGrouper.defaultProps = WithControlDefaultProps;

  return hoistNonReactStatics(WithControlGrouper, WrappedComponent);
};

export default withControlGrouper;
